// Ui3
import Modal from 'ui3/Modal/Modal';
import Text from 'ui3/Text/Text';
import Button from 'ui3/Button/Button';
// Helpers
import { getEnvLink } from 'helpers/routes';
// Styles
import styles from './PurchaseSuccessModal.module.scss';

interface PurchaseSuccessModalProps {
  open: boolean;
  onClose: () => void;
}

const PurchaseSuccessModal: React.FC<PurchaseSuccessModalProps> = ({
  open,
  onClose,
}) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      showCloseIcon={false}
      size="small"
      className={styles.modal}
      containerClassName={styles.modalContainer}
    >
      <div className={styles.root}>
        <img
          src={`${getEnvLink()}/images/watch-stream-images/golden-camera.png`}
          alt="golden-camera"
          className={styles.image}
        />
        <Text variant="h3" className={styles.title}>
          You&apos;re all set!
        </Text>
        <Text variant="body2Regular" className={styles.message}>
          Please note: The event organizer is responsible for the quality of the
          stream. MILLIONS is a distribution platform and does not control or
          produce the content. MILLIONS.co took all necessary steps to test and
          prepare our platform for this event.
        </Text>
        <Button variant="primary" className={styles.button} onClick={onClose}>
          Got It!
        </Button>
      </div>
    </Modal>
  );
};

export default PurchaseSuccessModal;
